import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CloseIcon from "@mui/icons-material/Close";
import ContactSupportOutlined from "@mui/icons-material/ContactSupportOutlined";
import IconButton from "@mui/material/IconButton";
import { colors } from "healthex-common/colors";
import React from "react";
import styled, { css } from "styled-components";
import { HXMobileButton } from "./HXButton";
import { FlexColumn } from "./common.styles";
export const BackButton = styled(IconButton).attrs({
    size: "medium",
    children: React.createElement(ChevronLeftIcon),
}) `
    align-self: start;
    ${(props) => props.hidden &&
    css `
            visibility: hidden;
        `}
`;
export const SupportOutlineButton = styled(IconButton).attrs({
    size: "medium",
    children: React.createElement(ContactSupportOutlined),
}) ``;
export const CloseButton = styled(IconButton).attrs({
    size: "medium",
    children: React.createElement(CloseIcon),
}) ``;
export const ProgressBarContainer = styled.div `
    align-self: stretch;
    height: ${(props) => (props.fullWidth ? "4px" : "8px")};
    flex-shrink: 0;
    border-radius: ${(props) => (props.fullWidth ? "0px" : "100px")};
    background: ${colors.black_12};
    overflow: hidden;
    position: relative;
`;
export const ProgressBarInner = styled.div `
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 50%;
    width: ${(props) => `${props.width}%`};
    border-radius: 0px;
    background: linear-gradient(135deg, ${colors.accents_gradient_start} 0%, ${colors.accents_sunset} 100%);
`;
export const SaveAndExitButton = styled(HXMobileButton) `
    height: 33px;
`;
export const VideoContainer = styled(FlexColumn) `
    align-items: center;
`;
export const PatientConsentManagerLoadingContainer = styled(FlexColumn) `
    align-self: stretch;
    align-items: center;
    justify-content: center;
    height: 100%;
`;
